var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlassCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 321,
    height: 177,
    viewBox: "0 0 321 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_3884_9935)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 1,
    width: 175,
    height: 319,
    rx: 16,
    transform: "rotate(90 320 1)",
    fill: "url(#paint0_radial_3884_9935)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.5,
    y: 0.5,
    width: 176,
    height: 320,
    rx: 16.5,
    transform: "rotate(90 320.5 0.5)",
    stroke: "url(#paint1_radial_3884_9935)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.5,
    y: 0.5,
    width: 176,
    height: 320,
    rx: 16.5,
    transform: "rotate(90 320.5 0.5)",
    stroke: "url(#paint2_radial_3884_9935)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.5,
    y: 0.5,
    width: 176,
    height: 320,
    rx: 16.5,
    transform: "rotate(90 320.5 0.5)",
    stroke: "url(#paint3_linear_3884_9935)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_3884_9935",
    x: -42,
    y: -42,
    width: 405,
    height: 261,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 21
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3884_9935"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3884_9935",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3884_9935",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(320 1) rotate(61.2513) scale(363.849 213.217)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3884_9935",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(407.5 160.5) rotate(90) scale(159.5 141.388)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C4424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C4424",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3884_9935",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(407.5 160.5) rotate(90) scale(159.5 3.54592)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F53E02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53E02",
    stopOpacity: 0.58
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3884_9935",
    x1: 407.5,
    y1: 1,
    x2: 407.5,
    y2: 320,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassCard);
export default __webpack_public_path__ + "static/media/GlassCard.dcf78be4e2388665e0a6b4e443359f2f.svg";
export { ForwardRef as ReactComponent };